export default "__VITE_ASSET__d60dd4c4__"